import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

import { ISupplierInboxJob } from '../../../interfaces/inbox-job';
import { IInboxJobFilter } from '../../../interfaces/inbox-job-filter';
import { InboxJobsService, SupplierJobStoreService } from '../../../services';
import { InputHelper } from '../../../utils/input.helper';
import { Router } from '@angular/router';
import { LazyLoadEvent, MessageService } from 'primeng';
import { Subscription } from 'rxjs';
import { SupplierJobChannel } from '../../../enums/supplier-job-channel';
import { SupplierInboxType } from '../../../enums/supplier-inbox.type.enum';
import { DatexPipe } from '../../../pipes/date-format-pipe/datex';

@Component({
  selector: 'supplier-jobs-grid',
  templateUrl: './supplier-jobs-grid.component.html',
  styleUrls: ['./supplier-jobs-grid.component.scss'],
  encapsulation: ViewEncapsulation.None, // todo check,
  providers: [DatexPipe],
})
export class SupplierJobsGridComponent implements OnInit {
  private subscriptions: Subscription[] = [];

  public selectedJob: ISupplierInboxJob;

  public SupplierInboxType = SupplierInboxType;

  //---exported params
  private _inboxType: SupplierInboxType;
  private _filterVal: IInboxJobFilter;

  @Input('filterVal')
  set filterVal(value: IInboxJobFilter) {
    this._filterVal = value;

    if (this._filterVal?.filters?.inboxType) {
      this._filterVal.filters.inboxType.value = this._inboxType;
    }

    if (value != null && Object.keys(value).length !== 0) {
      this.supplierJobStoreService.getPage(this._filterVal, true);
    }
  }

  get filterVal(): IInboxJobFilter {
    return this._filterVal;
  }

  @Input() supplierJobChannel: SupplierJobChannel;

  @Input('inboxType')
  set inboxType(value: SupplierInboxType) {
    this._inboxType = value;
  }

  get inboxType(): SupplierInboxType {
    return this._inboxType;
  }

  constructor(
    private router: Router,
    public messageService: MessageService,
    public inputHelper: InputHelper,
    public supplierJobStoreService: SupplierJobStoreService,
    public datexPipe: DatexPipe,
  ) {}

  allocateDriverClick = () => this.supplierJobStoreService.setAllocateDriverDialogVisible$(true);

  ngOnInit() {
    const sub = this.supplierJobStoreService.selectedJob$.subscribe((job) => {
      this.selectedJob = job;
    });

    this.subscriptions.push(sub);
  }

  load(filter: IInboxJobFilter) {
    this.supplierJobStoreService.getPage(filter);
  }

  get isInbox() {
    return this.inboxType <= SupplierInboxType.InboxRejected;
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    if (typeof event.first != 'undefined') {
      this.filterVal.first = event.first;
      this.supplierJobStoreService.getPage(this.filterVal);
    }

    if (typeof event.sortField != 'undefined') {
      this.filterVal.sortField = event.sortField;
      this.filterVal.sortOrder = event.sortOrder;
    }
  }

  itemsCountPostfix(value: string, count: number) {
    if (value == null || value == '' || count < 2) return value;
    return value + ' (+' + (count - 1) + ')';
  }

  itemsCountPostfixHtml(value: string, count: number) {
    if (value == null || value == '' || count < 2) return value;
    return value + ' <b>(+' + (count - 1) + ')</b>';
  }

  tasksCountPostfix(item: ISupplierInboxJob, value: string) {
    return this.itemsCountPostfix(value, item.tasks.length);
  }

  vehicleCountPostfix(item: ISupplierInboxJob, value: string) {
    return this.itemsCountPostfix(value, item.vehiclesNum);
  }

  tasksCountPostfixHtml(item: ISupplierInboxJob, value: string) {
    return this.itemsCountPostfixHtml(value, item.tasks.length);
  }

  vehicleCountPostfixHtml(item: ISupplierInboxJob, value: string) {
    return this.itemsCountPostfixHtml(value, item.vehiclesNum);
  }

  onShowPriceDetails($event: MouseEvent) {
    if (this.showPriceDetailsEnabled) {
      this.supplierJobStoreService.goToPriceDetails(this.selectedJob.id, $event);
    }
  }

  get showPriceDetailsEnabled(): boolean {
    return (
      this.inboxType == SupplierInboxType.ExistingClosed ||
      this.inboxType == SupplierInboxType.ExistingCancelled
    );
  }

  get showUnWatchBtn(): boolean {
    return (
      this.inboxType != SupplierInboxType.InboxDirect &&
      this.inboxType != SupplierInboxType.InboxRejected &&
      this.selectedJob?.supplierWatching
    );
  }

  get showWatchBtn(): boolean {
    return (
      this.inboxType != SupplierInboxType.InboxDirect &&
      this.inboxType != SupplierInboxType.InboxRejected &&
      !this.selectedJob?.supplierWatching
    );
  }

  acceptJobClick() {
    this.supplierJobStoreService.setAcceptJobDialogVisible(true);
  }

  shortMovementType(movementType: string): string {
    if (movementType == 'Driven Insured') {
      return 'Driven';
    }

    return movementType;
  }

  showPriceDetails() {
    var param: any = {
      jobId: this.selectedJob.id,
    };

    this.router.navigate(['app/pricedetails'], { queryParams: param });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x?.unsubscribe());
  }

  asInboxJob(itemUntyped: any): ISupplierInboxJob {
    return itemUntyped as ISupplierInboxJob;
  }

  unHideJob(jobId: number) {
    this.selectedJob = null;
    this.supplierJobStoreService.unHideJob(jobId).then(() => {
      this.supplierJobStoreService.removeJob(jobId);
    });
  }
  get displaySupplierPrice() {
    return this.isInbox || (!this.isInbox && this.inboxType != SupplierInboxType.ExistingCancelled);
  }

  get displayTotalPrice() {
    return this.inboxType == SupplierInboxType.ExistingCancelled;
  }
}
